module.exports = __webpack_public_path__ + "static/shape-two-5070f64d8d8b45685febeae3c52818a6.png";